module.exports = __webpack_public_path__ + "static/media/beach.af15909e.jpg";